import {
  useGetBeamerChannel,
  useGetCurrentUser,
  useGetCurrentUserChannels,
  useGetCurrentUserFavorites,
  useGetCurrentUserHouses,
} from 'gcs-common/clients/api/entities/current-user/current-user-api';
import { useUpdateAgentStatus } from 'gcs-common/clients/api/entities/current-user/current-user-hooks';
import LoadingPage from 'gcs-common/components/LoadingPage/LoadingPage';
import { ALL_CHANNEL_TYPES } from 'gcs-common/helper/channelTypeHelper';
import { ONLINE_STATUS } from 'gcs-common/helper/userStatusHelper';
import useMsTeamsNotificationRouting from 'gcs-common/hooks/use-ms-teams-notification-routing';
import { getInitialLogin } from 'gcs-common/slices/auth/authSelectors';
import { setIsInitialLogin } from 'gcs-common/slices/auth/authSlice';
import moment from 'moment';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { useWebPushNotifications } from '../../push-notifications/use-web-push-notifications';

const LoggedInRoot = () => {
  const dispatch = useDispatch();
  const { updateAgentStatus } = useUpdateAgentStatus();
  const { data: currentUser } = useGetCurrentUser();
  const isInitialLogin = useSelector(getInitialLogin);

  useWebPushNotifications();
  useMsTeamsNotificationRouting();

  useEffect(() => {
    if (currentUser?.isAgent) {
      const lastUpdate = currentUser.status?.updatedAt;
      const now = moment().format();
      const isStatusUpdatedToday = moment(now).isSame(lastUpdate, 'day');
      if (!isStatusUpdatedToday) {
        updateAgentStatus({ statusType: ONLINE_STATUS.ONLINE });
      } else if (isInitialLogin) {
        updateAgentStatus({ statusType: ONLINE_STATUS.IDLE });
      }
    }
    if (isInitialLogin) {
      dispatch(setIsInitialLogin(false));
    }
  }, []);
  useGetCurrentUserFavorites();
  const { isFetchedAfterMount: isFetchedAfterMountHouses } = useGetCurrentUserHouses();
  const { isFetchedAfterMount: isFetchedAfterMountChannels } = useGetCurrentUserChannels({
    query: {
      channel_types: ALL_CHANNEL_TYPES,
    },
  });
  const { isFetchedAfterMount: isFetchedAfterMountBeamerChannel } = useGetBeamerChannel();

  if (!isFetchedAfterMountHouses || !isFetchedAfterMountChannels || !isFetchedAfterMountBeamerChannel) {
    return <LoadingPage />;
  }

  return <Outlet />;
};

export default LoggedInRoot;
